import { builderFetch } from '../../utilities';

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.notes;

/**
 * Sets new recipe notes meta "uap_recipe_notes"
 *
 * @param {String} newNotes The recipe notes
 * @return {Promise} The apiFetch promise
 */
const setRecipeNotes = ( newNotes ) => {
	// Save the recipe title
	return builderFetch( {
		endpoint: 'change_recipe_notes',
		method: 'POST',
		data: {
			// eslint-disable-next-line camelcase
			post_ID: UncannyAutomator._recipe.recipe_id,
			// eslint-disable-next-line camelcase
			notes: newNotes
		},
		snackbar: {
			loading: strings.updating,
			success: strings.updated,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/set-recipe-notes', {
				detail: {
					recipeNotes: newNotes
				}
			} ) );
		}

		return response;
	} );
}

export default setRecipeNotes;
